import Vue from 'vue'
import Vuex from 'vuex'
import global from "@/store/modules/global";
import other from './modules/other'
import subject from './modules/subject'
import questionBank from './modules/questionBank'
import questionTag from './modules/questionTag'
import question from './modules/question'
import paper from './modules/paper'
import arrangeExam from './modules/arrangeExam'
import training from './modules/training'
import permissions from './modules/permissions'
import trainingEnvironment from './modules/trainingEnvironment'
import achievement from './modules/achievement'
import marking from './modules/marking'
import reviewTeacherList from './modules/reviewTeacherList'
import projectConfig from './modules/projectConfig.js' // 项目配置文件

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        global,
        permissions,
        other,
        subject,
        questionBank,
        questionTag,
        question,
        paper,
        arrangeExam,
        training,
        trainingEnvironment,
        achievement,
        marking,
        reviewTeacherList,
        projectConfig,
    }
})
